import { apiSlice } from "./api";

const fields = [
  'id', 'name', 'slug', 'parent', 'description', 'meta',
].join(',');

export const atfCategoryApiSlice = apiSlice.injectEndpoints({
    endpoints: build => ({
      getCategories: build.query({
        query: () => `atf_category/?per_page=100&_fields=${fields}`,
        providesTags: (result) =>
          result
            ? [
                ...result.map(({ id }) => ({ type: 'atf_category', id })),
                { type: 'atf_category', id: 'LIST' },
              ]
            : [{ type: 'atf_category', id: 'LIST' }],
      }),
    }),
    overrideExisting: true,
});

export const { 
    useGetCategoriesQuery
} = atfCategoryApiSlice;
